<template>
  <section>
    <div v-for="day of daily" :key="day.id" class="row custom-row">
      <div class="row mb-2">
        <div class="col-md-4 custom-day-header">
          <a href="#client-tabs">
            <i class="fas fa-caret-up"></i>
          </a>
          <h5 :id="`pictures-${day.name}`">{{ day.name }}</h5>
        </div>
        <div class="col-md-4">
          <progress-gauge
            v-if="day.ratings.length > 0"
            :progress="day.ratings"
          />
        </div>
        <div class="col-md-4"></div>
      </div>
      <div class="row">
        <div class="col-md-12 custom-table">
          <table v-if="day.food.length > 0">
            <tbody>
              <tr>
                <td
                  v-for="(food, idx) of day.food"
                  :key="idx"
                  class="custom-food"
                >
                  <img
                    v-if="food.UserRating > 0"
                    src="/media/ic_rate_good.png"
                    width="25"
                  />
                  <img
                    v-else-if="food.UserRating == 0"
                    src="/media/ic_rate_neutral.png"
                    width="25"
                  />
                  <img v-else src="/media/ic_rate_bad.png" width="25" />
                  <span class="custom-date">
                    {{ formatDate(food.FoodDateTime) }}
                  </span>
                  <i
                    v-if="food.Note !== ''"
                    class="far fa-sticky-note custom-note"
                    :title="food.Note"
                  ></i>
                </td>
              </tr>
              <tr>
                <td
                  v-for="(food, idx) of day.food"
                  :key="idx"
                  class="custom-food"
                >
                  <div
                    data-toggle="tooltip"
                    :title="food.Note"
                    class="custom-note"
                  >
                    <div
                      v-if="food.ImageUrl !== null"
                      :class="{ 'custom-background': food.manual_type == 5 }"
                    >
                      <img
                        height="260"
                        :id="`img_${food.id}`"
                        :src="food.ImageUrl"
                      />
                    </div>
                    <div v-else>
                      <div
                        v-if="food.manual_type === 1"
                        class="custom-food-image"
                      >
                        <span>BREAKFAST</span>
                        <img
                          height="150"
                          :id="`img_${food.id}`"
                          src="/media/ic_breakfast_black_64dp.png"
                        />
                        <div class="custom-generic-note">{{ food.Note }}</div>
                      </div>
                      <div
                        v-else-if="food.manual_type === 2"
                        class="custom-food-image"
                      >
                        <span>LUNCH</span>
                        <img
                          height="150"
                          :id="`img_${food.id}`"
                          src="/media/ic_lunch_black_64dp.png"
                        />
                        <div class="custom-generic-note">{{ food.Note }}</div>
                      </div>
                      <div
                        v-else-if="food.manual_type === 3"
                        class="custom-food-image"
                      >
                        <span>DINNER</span>
                        <img
                          height="150"
                          :id="`img_${food.id}`"
                          src="/media/ic_dinner_black_64dp.png"
                        />
                        <div class="custom-generic-note">{{ food.Note }}</div>
                      </div>
                      <div
                        v-else-if="food.manual_type === 4"
                        class="custom-food-image"
                      >
                        <span>OTHER</span>
                        <img
                          height="150"
                          :id="`img_${food.id}`"
                          src="/media/ic_other_meal_black_64dp.png"
                        />
                        <div class="custom-generic-note">{{ food.Note }}</div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ProgressGauge from '@/Components/UserCardio/elements/progress-gauge'
export default {
  name: 'nutrition-daily',
  components: {
    ProgressGauge,
  },
  data() {
    return {
      days: [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday',
      ],
    }
  },
  computed: {
    ...mapGetters('nutrition', ['nutrition']),
    daily() {
      let _data = []
      if (this.nutrition) {
        for (var i = 0; i < this.days.length; i++) {
          let day = this.days[i]
          let ratings = []
          if (this.nutrition.food.days) {
            ratings.push(this.nutrition.food.days[day].badPct)
            ratings.push(this.nutrition.food.days[day].neutralPct)
            ratings.push(this.nutrition.food.days[day].goodPct)
          } else {
            ratings.push(100)
          }
          let food = []
          if (this.nutrition.food.days[day].food) {
            food = this.nutrition.food.days[day].food
          }
          _data.push({
            id: i,
            name: day,
            letter: day.substring(0, 1).toUpperCase(),
            ratings: ratings,
            food: food,
          })
        }
      }
      return _data
    },
  },
  methods: {
    formatDate(date) {
      return moment.utc(date).format('hh:mm a')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-row {
  margin-top: 10px;
  border-bottom: 1px solid rgb(222, 226, 230);
}
.custom-day-header {
  display: inline-flex;
  a {
    text-decoration: none;
    cursor: pointer;
    margin-right: 5px;
  }
}
.custom-food {
  position: relative;
  text-align: center;
  vertical-align: bottom;
  margin: 0 auto;
  padding: 10px;
}
.custom-note {
  position: relative;
  font-size: 1.4em;
  top: 5px;
  left: 10px;
  cursor: pointer;
}
.custom-date {
  font-size: 1.2em;
  margin-left: 10px;
}
.custom-table {
  overflow: auto;
}
.custom-food-image {
  height: 260px;
  width: 200px;
  background-color: rgb(194, 194, 194);
  span {
    font-size: 1.1em;
    font-weight: 500;
  }
}
.custom-generic-note {
  font-size: 0.9em !important;
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 95%;
  transform: translate(-50%, -50%);
}
.custom-background {
  position: relative;
  background-color: rgb(194, 194, 194);
  width: 195px;
  height: 260px;
  padding: 20px;
  text-align: center;
  img {
    margin-top: 60px;
    width: 96px;
    height: 96px;
  }
}
</style>
